import { mapState } from 'vuex'

export default {
  computed: {
    isFirstStep () {
      let routes = this.$router.options.routes
      let currentRouteName = this.$route.name
      let firstRouteName = this.customstates.firstRouteName()
      let currentRouteIndex = routes.findIndex((route) => route.name === currentRouteName)
      let firstRouteIndex = routes.findIndex(route => route.name === firstRouteName)
      return currentRouteIndex === firstRouteIndex
    },
    isLastStep () {
      let routes = this.$router.options.routes
      let currentRouteName = this.$route.name
      let lastRouteName = this.customstates.lastRouteName()
      let currentRouteIndex = routes.findIndex((route) => route.name === currentRouteName)
      let lastRouteIndex = routes.findIndex(route => route.name === lastRouteName)

      // console.log('currentRouteName', currentRouteName)
      // console.log('currentRouteIndex', currentRouteIndex)
      // console.log('routes.length', routes.length)
      // console.log('routes', routes)

      // The last route is the second from the last route in the routes array.
      //  The last record in the routes array is the "catch all" redirect
      return currentRouteIndex === lastRouteIndex
    },
    previousRouteHref () {
      let previousRouteName = this.prevRouteName()
      return this.$router.resolve({ name: previousRouteName }).href
    },
    nextRouteHref () {
      let nextRouteName = this.nextRouteName()
      return this.$router.resolve({ name: nextRouteName }).href
    },
    ...mapState([
      // map this.customband to store.state.customband
      'customstates'
    ])
  },

  methods: {
    prevRouteName () {
      let currentRouteName = this.$route.name
      return this.customstates.previousStateName(currentRouteName)
    },
    nextRouteName () {
      let currentRouteName = this.$route.name
      return this.customstates.nextStateName(currentRouteName)
    },
    prevStep () {
      let previousRouteName = this.prevRouteName()
      this.$router.push({ name: previousRouteName })
    },
    nextStep () {
      let nextRouteName = this.nextRouteName()
      this.$router.push({ name: nextRouteName })
    }
  }
}
